import { ButtonPrimary, ButtonSize, IconLoader } from '@ui/src';
import WebhooksForm from '../../../components/settings/details-form/webhooks-form';
import useWebhooks from './hooks/use-webhooks';

import cn from '../styles.module.css';

const PspWebhooks = () => {
  const {
    isLoading,
    errorList,
    control,
    errors,
    onSubmit,
    globalError,
    editIsLoading,
    isDirty,
  } = useWebhooks();

  let content;

  if (isLoading) {
    content = (
      <div className={cn.settingsLoader}>
        <IconLoader />
      </div>
    );
  } else {
    content = (
      <>
        {!errorList && (
          <WebhooksForm control={control} errors={errors} onSubmit={onSubmit}>
            <>
              {globalError && (
                <div className={cn.saveGlobalError}>{globalError}</div>
              )}
              <ButtonPrimary
                text={editIsLoading ? 'Loading...' : 'Save'}
                onClick={onSubmit}
                bold
                size={ButtonSize.MEDIUM}
                disabled={editIsLoading || !isDirty}
                className={cn.saveDetailsButton}
              />
            </>
          </WebhooksForm>
        )}
        {errorList && (
          <div className={cn.loadingError}>
            <div className={cn.loadingErrorTitle}>Unable to load data</div>
            <div className={cn.loadingErrorText}>{errorList}</div>
          </div>
        )}
      </>
    );
  }

  return content;
};

export default PspWebhooks;
